import { Link } from "react-router";
import { CookieSettingsLink } from "./CookieBanner";
import { useI18n } from "../i18n/I18nProvider";
import { useCatalog } from "../lib/CatalogProvider";
import { INFO_PAGES, type InfoGroup } from "../pages/info/pages";
import { CONSUMER_URL } from "../pages/info/types";

export function Footer() {
  const { t, pick, locale } = useI18n();
  const { settings } = useCatalog();
  const column = (group: InfoGroup) =>
    INFO_PAGES.filter((p) => p.group === group).map((p) => (
      <li key={p.path}>
        <Link to={p.path}>{p.doc[locale].title}</Link>
      </li>
    ));

  return (
    <footer className="site-footer">
      <div className="container footer-inner footer-columns">
        <div>
          <strong className="footer-logo">pokefans.fun</strong>
          <p>{t("site.tagline")}</p>
          {settings.contact_email && <p>{pick(settings.contact_email)}</p>}
          {settings.whatsapp && <p>WhatsApp: {pick(settings.whatsapp)}</p>}
        </div>
        <nav aria-labelledby="footer-legal">
          <strong id="footer-legal">{t("footer.legal")}</strong>
          <ul>{column("legal")}</ul>
        </nav>
        <nav aria-labelledby="footer-resources">
          <strong id="footer-resources">{t("footer.resources")}</strong>
          <ul>
            <li>
              <Link to="/vender">{t("sell.metaTitle")}</Link>
            </li>
            <li>
              <Link to="/compramos">{t("buy.metaTitle")}</Link>
            </li>
            {column("resources")}
          </ul>
        </nav>
      </div>
      <div className="container footer-legal">
        {/* Res. SCI 424/2020: the withdrawal link, visible on the home page (and every page) with no sign-in needed. Only here. */}
        <Link to="/arrepentimiento" className="btn footer-withdraw">
          {t("footer.withdraw")}
        </Link>
        <p>
          <a href={CONSUMER_URL} target="_blank" rel="noopener noreferrer">
            {t("footer.consumer")}
          </a>
        </p>
        <p>{t("footer.disclaimer")}</p>
        <p>
          {t("footer.rights", { year: new Date().getFullYear() })} <CookieSettingsLink />
        </p>
      </div>
    </footer>
  );
}
